// @ts-nocheck
import React from 'react';
import WorkflowPage from './WorkflowPageFactory';
import { Individuals as IndividualsForm } from '../workflow/CompanyApp';

export default function IndividualsPage() {
  return (
    <WorkflowPage stepId="individuals">
      {({ data, setData, navigateTo }) => (
        <IndividualsForm formData={data} setFormData={setData} setActiveTab={navigateTo} />
      )}
    </WorkflowPage>
  );
}
